<template>
  <div class="checkout-steps w-full grid grid-cols-8 lg:grid-cols-3 gap-1 lg:gap-3 md:gap-3">
    <Tab
      :title="cartTab.title"
      :subtitle="cartTab.subtitle"
      :icon="cartTab.icon"
      :active="1 === active"
      :activeTab="active"
      :input="1"
      :onclick="onClick"
    />
    <div class="checkout-step__chevron flex pt-6 justify-center lg:hidden">
      <chevron-right-icon size="2x" style="color: #0e4333"></chevron-right-icon>
    </div>
    <Tab
      :title="addressTab.title"
      :subtitle="addressTab.subtitle"
      :icon="'home'"
      :active="2 === active"
      :activeTab="active"
      :input="2"
      :onclick="onClick"
    />
    <div class="checkout-step__chevron flex pt-6 justify-center lg:hidden">
      <chevron-right-icon size="2x" style="color: #0e4333"></chevron-right-icon>
    </div>
    <Tab
      :title="paymentTab.title"
      :subtitle="paymentTab.subtitle"
      :icon="'payment'"
      :active="3 === active"
      :activeTab="active"
      :input="3"
      :onclick="onClick"
      :hideArrow="true"
    />
  </div>
</template>
<script>
import Tab from './tab.vue';
import { ChevronRightIcon } from 'vue-feather-icons';
import { isClinicOrderApprovalFlowEnabled } from '@/globalHelpers/storeHelper';

export default {
  name: 'Tabs',
  components: {
    Tab,
    ChevronRightIcon,
  },
  props: {
    onClick: {
      type: Function,
      required: true,
    },
    active: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      cartTab: {
        title: '...',
        subtitle: '...',
        icon: '...',
      },
      addressTab: {
        title: '...',
        subtitle: '...',
      },
      paymentTab : {
        title: '...',
        subtitle: '...',
      },
    };
  },
  async mounted() {
    let orderApprovalFlowEnabled;
    const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');

    try {
      orderApprovalFlowEnabled = await isClinicOrderApprovalFlowEnabled(clinicId);
    } catch (error) {
      console.error('Error fetching clinic details:', error);
      orderApprovalFlowEnabled = false;
    }

    if (orderApprovalFlowEnabled) {
      this.cartTab.title = 'Review';
      this.cartTab.subtitle = 'Your Items';
      this.cartTab.icon = 'package';

      this.paymentTab.title = 'Payment';
      this.paymentTab.subtitle = 'Finalise Request';

      this.addressTab.title = 'Address';
      this.addressTab.subtitle = 'Enter Your Address';
    } else {
      this.cartTab.title = 'Cart';
      this.cartTab.subtitle = 'Your Cart Items';
      this.cartTab.icon = 'cart';

      this.paymentTab.title = 'Payment';
      this.paymentTab.subtitle = 'Enter Your Payment';

      this.addressTab.title = 'Address';
      this.addressTab.subtitle = 'Enter Your Address';
    }
  },
};
</script>
<style lang="scss">
@media (max-width: 1023px) {
  .checkout-steps {
    gap: 0 !important;
    align-items: flex-start;
  }

  .checkout-step__chevron {
    padding-top: 10px !important;
  }

  .checkout-step__chevron svg {
    width: 16px !important;
    height: 16px !important;
  }
}
</style>
